import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
class Checkbox extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      checked: this.props.defaultValue
    });
    _defineProperty(this, "handleCheckboxChange", event => {
      //Added this if statement for Checkbox.test.js
      this.setState({
        checked: event.target.checked
      });
      if (this.props.onChange) {
        this.props.onChange(event.target.checked);
      }
    });
  }
  render() {
    const {
      className
    } = this.props;
    const finalClass = `Checkbox ${className}`.trim();
    const inputAttribs = this.generateInputAttributes();
    return /*#__PURE__*/React.createElement("label", {
      className: finalClass
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: "Checkbox-input"
    }, inputAttribs)));
  }
  generateInputAttributes() {
    const {
      id,
      name,
      disabled
    } = this.props;
    const inputAttribs = {
      className: 'Checkbox-input',
      type: 'checkbox',
      onChange: this.handleCheckboxChange,
      disabled,
      id: this.props.id,
      name: this.props.name,
      checked: this.props.defaultValue
    };
    if (id) {
      inputAttribs.id = id;
    }
    if (name) {
      inputAttribs.name = name;
    }
    inputAttribs.checked = this.state.checked;
    return inputAttribs;
  }
}
_defineProperty(Checkbox, "defaultProps", {
  defaultValue: false,
  disabled: false,
  className: '',
  id: ''
});
export default Checkbox;